import styled from "@emotion/styled"
import Box, { BoxProps } from "./Box"
import { variant } from "styled-system"
import React, { forwardRef } from "react"

const Block = styled(Box)`
  ${variant({
    variants: {
      hero: {
        pt: [15, 15, 23],
        pb: [10, 10, 16],
      },
      heroApp: {
        pt: [7, "100px", 15],
        pb: [10, 10, 16],
      },
      hero2: {
        pt: [15, 15, 23],
        pb: [0, 0, 0],
      },
      default: {
        py: [10, 10, 16],
      },
      disclaimer: {
        pt: [10, 10, 16],
        pb: [10, 10, 8],
      },
      compact: {
        py: [10],
      },
      defaultNoPaddingTop: {
        pb: [10, 10, 16],
      },
      defaultNoPaddingBottom: {
        pt: [10, 10, 16],
      },
      earn: {
        pt: [10, 10, 16],
        pb: [10, 10, 0],
      },
      noDefiLanding: {
        pt: ["34px", "20px"],
        pb: [0, 9],
      },
      campaignLading: {
        pt: ["75px"],
        pb: ["50px"],
      },
      payHero: {
        pt: [6, 22, 17],
      },
      stakingETHHero: {
        pt: [6, 0],
        pb: [5, 0],
        pl: [3, 7, "150px"],
        pr: [3, 0],
      },
    },
  })}
`

interface ForwardedBlockProps extends BoxProps {
  variant?:
    | "hero"
    | "default"
    | "disclaimer"
    | "compact"
    | "defaultNoPaddingTop"
    | "defaultNoPaddingBottom"
    | "hero2"
    | "earn"
    | "noDefiLanding"
    | "campaignLading"
    | "payHero"
    | "stakingETHHero"
    | "heroApp"
}

const ForwardedBlock = forwardRef<HTMLAllCollection, ForwardedBlockProps>(
  ({ as = "section", variant = "default", ...props }, ref) => (
    <Block as={as} ref={ref} variant={variant} {...props} />
  )
)

ForwardedBlock.displayName = "Block"

export default ForwardedBlock
